export interface PurchaseProduct {
  id: number;
  type: 'single' | 'multi';
  name: string;
  areaCovered: string;
  coolingCapacity: string;
  heatingCapacity: string;
  powerSupply: string;
  price: number;
  rebateAmount: number;
  image: string;
}

export const purchaseProducts: PurchaseProduct[] = [
  {
    id: 1,
    type: 'single',
    name: 'DIY 9k BTU',
    areaCovered: 'Up to 400 sqft.',
    coolingCapacity: '9000 BTU',
    heatingCapacity: '10,000 BTU',
    powerSupply: '115V, 60Hz, 1PH',
    price: 2329,
    rebateAmount: 0,
    image: '/images/products/1-zone-diy.png',
  },
  {
    id: 2,
    type: 'single',
    name: 'DIY 12k BTU',
    areaCovered: 'Up to 550 sqft.',
    coolingCapacity: '12,000 BTU',
    heatingCapacity: '12,000 BTU',
    powerSupply: '115V, 60Hz, 1PH',
    price: 2359,
    rebateAmount: 0,
    image: '/images/products/1-zone-diy.png',
  },
  {
    id: 3,
    type: 'single',
    name: 'DIY 18k BTU',
    areaCovered: 'Up to 800 sqft.',
    coolingCapacity: '18,000 BTU',
    heatingCapacity: '18,000 BTU',
    powerSupply: '208-230V, 60Hz, 1PH',
    price: 2909,
    rebateAmount: 0,
    image: '/images/products/1-zone-diy.png',
  },
  {
    id: 4,
    type: 'single',
    name: 'DIY 24k BTU',
    areaCovered: 'Up to 1,050 sqft.',
    coolingCapacity: '23,000 BTU',
    heatingCapacity: '23,000 BTU',
    powerSupply: '208-230V, 60Hz, 1PH',
    price: 3329,
    rebateAmount: 0,
    image: '/images/products/1-zone-diy.png',
  },
  {
    id: 5,
    type: 'single',
    name: 'DIY 36k BTU',
    areaCovered: 'Up to 1,550 sqft.',
    coolingCapacity: '36,000 BTU',
    heatingCapacity: '36,000 BTU',
    powerSupply: '208-230V, 60Hz, 1PH',
    price: 3769,
    rebateAmount: 0,
    image: '/images/products/1-zone-diy.png',
  },
  {
    id: 6,
    type: 'multi',
    name: '3-Zone DIY',
    areaCovered: 'Up to 750 sqft.',
    coolingCapacity: '18,000 BTU',
    heatingCapacity: '18,000 BTU',
    powerSupply: '208-230V, 60Hz, 1PH',
    price: 0,
    rebateAmount: 0,
    image: '/images/products/3-zone-diy.png',
  },
  {
    id: 7,
    type: 'multi',
    name: '4-Zone DIY',
    areaCovered: 'Up to 1,125 sqft.',
    coolingCapacity: '26,000 BTU',
    heatingCapacity: '26,000 BTU',
    powerSupply: '208-230V, 60Hz, 1PH',
    price: 0,
    rebateAmount: 0,
    image: '/images/products/4-zone-diy.png',
  },
  {
    id: 8,
    type: 'multi',
    name: '5-Zone DIY',
    areaCovered: 'Up to 1,500 sqft.',
    coolingCapacity: '34,000 BTU',
    heatingCapacity: '36,000 BTU',
    powerSupply: '208-230V, 60Hz, 1PH',
    price: 0,
    rebateAmount: 0,
    image: '/images/products/5-zone-diy.png',
  },
  {
    id: 9,
    type: 'multi',
    name: '6-Zone DIY',
    areaCovered: 'Up to 2,000 sqft.',
    coolingCapacity: '43,000 BTU',
    heatingCapacity: '48,000 BTU',
    powerSupply: '208-230V, 60Hz, 1PH',
    price: 0,
    rebateAmount: 0,
    image: '/images/products/6-zone-diy.png',
  },
  {
    id: 10,
    type: 'multi',
    name: '6-Zone DIY',
    areaCovered: 'Up to 2,300 sqft.',
    coolingCapacity: '47,000 BTU',
    heatingCapacity: '55,000 BTU',
    powerSupply: '208-230V, 60Hz, 1PH',
    price: 0,
    rebateAmount: 0,
    image: '/images/products/6-zone-diy.png',
  },
];
